 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTTOC from '@/components/Text/TOC'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTA from '@/components/Text/A'
 import TEXTB from '@/components/Text/B'
 import TEXTC from '@/components/Text/C'
 import TEXTD from '@/components/Text/D'
 import TEXTE from '@/components/Text/E'
 import TEXTF from '@/components/Text/F'
 import TEXTG from '@/components/Text/G'
 import TEXTH from '@/components/Text/H'
 import TEXTI from '@/components/Text/I'
 import TEXTJ from '@/components/Text/J'
 import TEXTK from '@/components/Text/K'
 import TEXTL from '@/components/Text/L'
 import TEXTM from '@/components/Text/M'
 import TEXTN from '@/components/Text/N'
 import TEXTO from '@/components/Text/O'
 import TEXTP from '@/components/Text/P'
 import TEXTQR from '@/components/Text/QR'
 import TEXTS from '@/components/Text/S'
 import TEXTT from '@/components/Text/T'
 import TEXTU from '@/components/Text/U'
 import TEXTV from '@/components/Text/V'
 import TEXTW from '@/components/Text/W'
 import TEXTXYZ from '@/components/Text/XYZ'
 import TEXTBIBLIOGRAPHY from '@/components/Text/Bibliography'
 import TEXTABOUTTHEAUTHORS from '@/components/Text/AboutTheAuthors'
 import TEXTPOCKETREFCOLLECTION from '@/components/Text/PocketRefCollection'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Cover",
 			"name" : "Text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/TOC",
 			"name" : "Text/TOC",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/A",
 			"name" : "Text/A",
 			"component" : TEXTA
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js